import React, { useEffect, useState } from "react";
import { showToast } from "../../../Common/Messages";

const DocHistory = (props) => {
    const [historyData, setHistoryData] = useState([]);

    useEffect(() => {
        getHistory();
    }, []);

    const formattedDateTime = (dateTime) => {
        const year = dateTime.getFullYear();
        const month = String(dateTime.getMonth() + 1).padStart(2, '0');
        const date = String(dateTime.getDate()).padStart(2, '0');
        return `${year}-${month}-${date}`;
    }

    const getHistory = async () => {
        const docId = props.docId;
        const response = await fetch('api/Edit/GetHistory?DocId=' + docId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
        });
        const result = await response.json();
        if (response.status === 200 && result.data) {
            const tableData = result.data.table;
            if (tableData.length === 0) {
                showToast('danger', "히스토리가 존재하지 않습니다.");
            }
            const history = [];
            tableData.forEach(data => {
                history.push({
                    id: data.id,
                    status: data.status,
                    comment: data.comment || "",
                    updateDateTime: new Date(data.updateDateTime),
                    updateUserName: data.updateUserName,
                });
            });
            setHistoryData(history);
        } else {
            showToast('danger', "히스토리 조회를 실패했습니다. 다시 시도해주세요.");
            return;
        }
    }

    const onClickHistory = (data) => {
        if (!data.id || !data.id.startsWith("WK_")) {
            showToast('warning', "복원할 수 없는 히스토리입니다.");
            return;
        }
        props.onRestore(data);
    }

    return (
        <div className="editor-side">
            <div className="editor-side-top">
                <h3 className='title'>히스토리</h3>
                <button className="btn-close" onClick={props.onClose}>
                    <i className="icoKdc32 close"></i>
                </button>
            </div>
            <div className="editor-side-cnts">
                <div className="history-cnts">
                    {historyData.map((data, index) => {
                        return (
                            <div key={index} className="history-each" onClick={() => onClickHistory(data)}>
                                <h4 className="date">{formattedDateTime(data.updateDateTime)}</h4>
                                <div className="dot"></div>
                                <div className="history-btm">
                                    <p className="action">{data.status}</p>
                                    {data.comment !== "" && <p className="memo">{data.comment}</p>}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
};
export default DocHistory;
